import http from '../http'

export async function fetchCrmLeads(params = {}) {
    return await http.post('/crm/leads/list', params)
}

export async function fetchCrmLeadPage(params = {}) {
    // “我的线索”通过显式查询参数进入销售权限入口，避免复用线索池管理权限。
    const accessScope = params.scope === 'mine' ? '?scope=mine' : ''
    return await http.post(`/crm/leads/page${accessScope}`, params)
}

/** 获取当前账号权限范围内的线索池全局状态汇总。 */
export async function fetchCrmLeadSummary() {
    return await http.post('/crm/leads/summary')
}

/** 获取单条线索详情。 */
export async function fetchCrmLeadById(id) {
    return await http.post('/crm/leads/detail', {id})
}

export async function createCrmLead(payload) {
    return await http.post('/crm/leads', payload)
}

export async function assignCrmLead(id, payload) {
    return await http.post('/crm/leads/assign', {...payload, id})
}

export async function claimCrmLead(id, payload) {
    return await http.post('/crm/leads/claim', {...payload, id})
}

export async function createCrmLeadFollowRecord(id, payload) {
    return await http.post('/crm/leads/create-follow-record', {...payload, id})
}

export async function updateCrmLeadStatus(id, payload) {
    return await http.post('/crm/leads/update-status', {...payload, id})
}

export async function convertCrmLeadToOpportunity(id, payload) {
    return await http.post('/crm/leads/convert-opportunity', {...payload, id})
}

/** 安全逻辑删除未被商机引用的线索及其从属留痕。 */
export async function deleteCrmLead(id) {
    return await http.post('/crm/leads/delete', {id})
}

export async function fetchCrmCustomers(params = {}) {
    return await http.post('/crm/customers/list', params)
}

export async function fetchCrmCustomerPage(params = {}) {
    return await http.post('/crm/customers/page', params)
}

export async function createCrmCustomer(payload) {
    return await http.post('/crm/customers', payload)
}

export async function updateCrmCustomer(id, payload) {
    return await http.post('/crm/customers/update', {...payload, id})
}

/** 原创建人认领本人创建的历史未分配客户。 */
export async function claimCrmCustomer(id) {
    return await http.post('/crm/customers/claim', {id})
}

export async function updateCrmCustomerStatus(id, payload) {
    return await http.post('/crm/customers/update-status', {...payload, id})
}

/** 安全逻辑删除未被业务数据引用的客户档案。 */
export async function deleteCrmCustomer(id) {
    return await http.post('/crm/customers/delete', {id})
}

export async function fetchCrmContacts(params = {}) {
    return await http.post('/crm/contacts/list', params)
}

export async function fetchCrmContactPage(params = {}) {
    return await http.post('/crm/contacts/page', params)
}

/** 获取当前账号权限范围内的联系人全量统计，不受列表筛选影响。 */
export async function fetchCrmContactSummary() {
    return await http.post('/crm/contacts/summary')
}

export async function createCrmContact(payload) {
    return await http.post('/crm/contacts', payload)
}

export async function updateCrmContact(id, payload) {
    return await http.post('/crm/contacts/update', {...payload, id})
}

export async function updateCrmContactPrimary(id, payload) {
    return await http.post('/crm/contacts/set-primary', {...payload, id})
}

export async function fetchCrmOpportunities(params = {}) {
    return await http.post('/crm/opportunities/list', params)
}

export async function fetchCrmOpportunityPage(params = {}) {
    return await http.post('/crm/opportunities/page', params)
}

/** 获取当前账号权限范围内的商机全量汇总；周起始日可选且不透传列表筛选。 */
export async function fetchCrmOpportunitySummary(weekStart = '') {
    return await http.post('/crm/opportunities/summary', weekStart ? {weekStart} : undefined)
}

export async function createCrmOpportunity(payload) {
    return await http.post('/crm/opportunities', payload)
}

/** 商机详情维护项目关键信息，只更新报价前项目资料。 */
export async function updateCrmOpportunityProjectInfo(id, payload) {
    return await http.post('/crm/opportunities/update-project-info', {...payload, id})
}

/** 仅超级管理员可改派商机销售负责人，后端会再次校验角色和账号状态。 */
export async function updateCrmOpportunityOwner(id, payload) {
    return await http.post('/crm/opportunities/update-owner', {...payload, id})
}

/** 合同弹窗补全项目地点时只更新地址，避免覆盖商机其他项目资料。 */
export async function updateCrmOpportunityProjectAddress(id, payload) {
    return await http.post('/crm/contracts/update-opportunity-address', {...payload, id})
}

/** 商机管理新增报价前跟进记录，只写留痕，不推进阶段。 */
export async function createCrmOpportunityFollowRecord(id, payload) {
    return await http.post('/crm/opportunities/create-follow-record', {...payload, id})
}

export async function updateCrmOpportunityStage(id, payload) {
    return await http.post('/crm/opportunities/update-stage', {...payload, id})
}

/** 关闭成交前商机，关闭原因必填。 */
export async function closeCrmOpportunity(id, payload) {
    return await http.post('/crm/opportunities/close', {...payload, id})
}
